module.exports = __webpack_public_path__ + "static/1-92497935f38252d51f460355db50bf31.png";